module.exports = __webpack_public_path__ + "media/images/icons/graphic-7f79b3ce2319127d25aa3a77c524523b.svg";